import * as actionType from "../actions/actionTypes";
// pertanyaan
import update from "react-addons-update";

const initialState = {
  makeCaseBySchedule: false,
  doingMakeCase: false,
};

const ExamReducers = (state = initialState, action) => {
  switch (action.type) {
    case actionType.TEACHER_MAKE_CASE_BY_SCHEDULE:
      return {
        ...state,
        case_part: [],
        listImg: [],
        doingMakeCase: true,
        makeCaseBySchedule: true,
        statusSubmitted: false,
        scheduleSelected: {
          courseName: action.courseName,
          typeCase: action.typeCase,
          date: action.date,
          time: action.time,
          className: action.className,
          is_remedial: action.isRemedial,
        },
        schedules: {
          //for post request
          exam_schedule_id: action.scheduleId,
          school_id: action.schoolId,
          is_remedial: action.isRemedial,
        },
        cases: {
          name: "",
          school_id: action.schoolId,
          course_id: action.courseId,
          teacher_id: action.userId,
          class_label: action.className,
        },
        currentItemCase: {
          id: null,
          type_name: "",
          key: "",
          case_id: action.caseId,
          name: "",
          score_weight: "",
          random_question_order: false,
          random_choice_order: false,
          is_case_sensitive: false,
          case_questions: [
            {
              id: null,
              question: "",
              key: Date.now(),
            },
          ],
        },
      };

    case actionType.TEACHER_REMOVE_SCHEDULE_SELECTED:
      return {
        makeCaseBySchedule: false,
        doingMakeCase: false,
        doingEditCase: false,
      };

    case actionType.SET_CASE_NAME:
      return {
        ...state,
        cases: {
          ...state.cases,
          name: action.text,
        },
        currentItemCase: {
          ...state.currentItemCase,
        },
      };

    case actionType.CHOOSE_CASE_PART_PILGAN:
      return {
        ...state,
        currentItemCase: {
          ...state.currentItemCase,
          type_name: action.currentItemCase.type_name,
          key: action.currentItemCase.key,
          case_id: action.currentItemCase.case_id,
          case_questions: [
            {
              id: null,
              ...state.currentItemCase.case_questions[0],
              status_img: 0,
              file_attached: null,
              img_file: null,
              question: null,
              case_choices:
                action.currentItemCase.type_name === "pilihan ganda benar salah"
                  ? [
                    {
                      file_attached: null,
                      status_img: 0,
                      key: Date.now(),
                      id: null,
                      case_question_id: 0,
                      value: null,
                      is_correct: 0,
                      img_file: null,
                    },
                    {
                      file_attached: null,
                      status_img: 0,
                      key: Date.now(),
                      id: null,
                      case_question_id: 0,
                      value: null,
                      is_correct: 0,
                      img_file: null,
                    },
                  ]
                  : [
                    {
                      file_attached: null,
                      status_img: 0,
                      key: Date.now(),
                      id: null,
                      case_question_id: 0,
                      value: null,
                      is_correct: 0,
                      img_file: null,
                    },
                  ],
            },
          ],
        },
      };
    case actionType.CHOOSE_CASE_PART_MENJODOHKAN:
      return {
        ...state,
        currentItemCase: {
          ...state.currentItemCase,
          type_name: action.currentItemCase.type_name,
          key: action.currentItemCase.key,
          case_id: action.currentItemCase.case_id,
          random_choice_order: true,
          case_questions: [
            {
              id: null,
              ...state.currentItemCase.case_questions[0],
              status_img: 0,
              file_attached: null,
              img_file: null,
              question: null,
              case_choices: [
                {
                  id: null,
                  case_question_id: 0,
                  is_correct: 1,
                  value: null,
                  file_attached: null,
                  status_img: 0,
                  key: Date.now(),
                  img_file: null,
                  order: Date.now(),
                },
              ],
              case_choices_answers: [
                {
                  id: null,
                  case_question_id: 0,
                  case_choice_id: Date.now(),
                  is_correct: 1,
                  value: null,
                  file_attached: null,
                  status_img: 0,
                  key: Date.now(),
                  img_file: null,
                  order: Date.now(),
                },
              ],
            },
          ],
        },
      };

    case actionType.CHOOSE_CASE_PART_ESSAY:
      return {
        ...state,
        currentItemCase: {
          ...state.currentItemCase,
          case_id: action.currentItemCase.case_id,
          type_name: action.currentItemCase.type_name,
          key: action.currentItemCase.key,
          case_questions: [
            {
              id: null,
              key: Date.now(),
              ...state.currentItemCase.case_questions[0],
              status_img: 0,
              case_choices: [],
              file_attached: null,
              img_file: null,
              question: null,
            },
          ],
        },
      };

    case actionType.ADD_CASE_PART: {
      const newPartType = action.casePart.type_name;
      const existingPartSameType = state.case_part.find(p => p.type_name === newPartType);
      const inheritedWeight = existingPartSameType ? existingPartSameType.score_weight : 0;
      
      const newCasePart = {
        ...action.casePart,
        random_choice_order: newPartType === 'menjodohkan' ? true : (action.casePart.random_choice_order || false),
        score_weight: inheritedWeight
      };

      return {
        ...state,
        case_part: [...state.case_part, newCasePart],
        currentItemCase: {
          ...state.currentItemCase,
          type_name: action.currentItemCase.type_name,
          key: action.currentItemCase.key,
          case_questions: [
            {
              ...state.case_questions,
              id: null,
              key: Date.now(),
              case_choices: [],
              file_attached: null,
            },
          ],
        },
      };
    }

    case actionType.DELETE_CASE_PART:
      return {
        ...state,
        case_part: [...state.case_part.slice(0, action.indexDeleted), ...state.case_part.slice(action.indexDeleted + 1)],
      };

    case actionType.SET_RANDOM_QUESTION:
      return update(state, {
        case_part: {
          [action.keyIndex]: {
            random_question_order: {
              $set: !state.case_part[action.keyIndex].random_question_order,
            },
          },
        },
      });

    case actionType.SET_RANDOM_ANSWER:
      if (state.case_part[action.keyIndex]?.type_name === "menjodohkan") {
        return state;
      }
      return update(state, {
        case_part: {
          [action.keyIndex]: {
            random_choice_order: {
              $set: !state.case_part[action.keyIndex].random_choice_order,
            },
          },
        },
      });
    case actionType.SET_CASE_SENSITIVE_ANSWER:
      return update(state, {
        case_part: {
          [action.keyIndex]: {
            is_case_sensitive: {
              $set: !state.case_part[action.keyIndex].is_case_sensitive,
            },
          },
        },
      });

    case actionType.SET_SCORE_WEIGHT: {
      const targetType = state.case_part[action.keyIndex]?.type_name;
      const newCasePart = state.case_part.map((part) => {
        if (part.type_name === targetType) {
          return { ...part, score_weight: action.text };
        }
        return part;
      });
      return {
        ...state,
        case_part: newCasePart,
      };
    }

    case actionType.SET_CASE_PART_NAME:
      return update(state, {
        case_part: {
          [action.keyIndex]: {
            name: { $set: action.text },
          },
        },
      });

    case actionType.ADD_QUESTION:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              id: { $set: null },
              $splice: [[action.keyIndexQues, 0, action.case_questions]],
            },
          },
        },
      });
    case actionType.ADD_QUESTION_MENJODOHKAN:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              id: { $set: null },
              $splice: [[action.keyIndexQues, 0, action.case_questions]],
            },
          },
        },
      });

    case actionType.ADD_QUESTION_TRUE_FALSE:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              id: { $set: null },
              $splice: [[action.keyIndexQues, 0, action.case_questions]],
            },
          },
        },
      });

    case actionType.DELETE_QUESTION:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: { $splice: [[action.keyIndexQues, 1]] },
          },
        },
      });

    case actionType.SET_QUESTION:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                question: { $set: action.text },
              },
            },
          },
        },
      });

    case actionType.SET_KD_UNIT:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                kd_id: { $set: action.kdId },
                kd_description: { $set: action.kdDescription },
                kd_unit_id: { $set: action.kdUnitId },
                kd_unit_description: { $set: action.kdUnitDescription },
                kd_unit: { $set: action.kdUnitString },
              },
            },
          },
        },
      });

    case actionType.SET_VIDEO_EMBED:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                video_embed: { $set: action.text },
              },
            },
          },
        },
      });

    case actionType.ADD_ANSWEAR:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  $splice: [[action.keyIndexAns, 0, action.case_choices]],
                },
              },
            },
          },
        },
      });
    case actionType.ADD_CHOICE_MENJODOHKAN:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  $splice: [[action.keyIndexAns, 0, action.case_choices]],
                },
                case_choices_answers: {
                  $splice: [[action.keyIndexAns, 0, action.case_choices_answers]],
                },
              },
            },
          },
        },
      });
    case actionType.ADD_CHOICE_ANSWER_MENJODOHKAN:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices_answers: {
                  $splice: [[action.keyIndexAns, 0, action.case_choices_answers]],
                },
              },
            },
          },
        },
      });
    case actionType.ADD_ANSWEAR_MULTIPLE:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  $splice: [[action.keyIndexAns, 0, action.case_choices]],
                },
              },
            },
          },
        },
      });

    case actionType.DELETE_ANSWEAR:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: { $splice: [[action.keyIndexAns, 1]] },
              },
            },
          },
        },
      });
    case actionType.DELETE_ANSWEAR_MENJODOHKAN:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: { $set: action.newcase_choices },
                case_choices_answers: { $set: action.newcase_choices_answers },
              },
            },
          },
        },
      });
    case actionType.DELETE_CASE_ANSWEAR_MENJODOHKAN:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: { $set: action.newcase_case_choices },
                case_choices_answers: { $set: action.newcase_choices_answers },
              },
            },
          },
        },
      });
    case actionType.DELETE_ANSWEAR_MULTIPLE:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: { $splice: [[action.keyIndexAns, 1]] },
              },
            },
          },
        },
      });

    case actionType.SET_ANSWEAR:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  [action.keyIndexAns]: {
                    value: { $set: action.text },
                  },
                },
              },
            },
          },
        },
      });
    case actionType.SET_ANSWEAR_CASE_CHOICES:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: { $set: action.texcase_choices_answers },
              },
            },
          },
        },
      });
    case actionType.SET_ANSWEAR_CHOICES:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices_answers: { $set: action.texcase_choices_answers },
              },
            },
          },
        },
      });
    case actionType.SET_ANSWEAR_TRUE_FALSE:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: { $set: action.case_questionsss },
          },
        },
      });

    case actionType.SET_ANSWEAR_SHORT:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  [action.keyIndexAns]: {
                    value: { $set: action.text },
                  },
                },
              },
            },
          },
        },
      });
    case actionType.SET_ANSWEAR_MULTIPLE:
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  [action.keyIndexAns]: {
                    value: { $set: action.text },
                  },
                },
              },
            },
          },
        },
      });

    case actionType.SELECT_CORRECT_ANSWER: // pertanyaan
      if (action.keyIndexAnsPre < 0)
        //Bila belum ada jawaban
        return update(state, {
          case_part: {
            [action.keyIndexPart]: {
              case_questions: {
                [action.keyIndexQues]: {
                  case_choices: {
                    [action.keyIndexAns]: {
                      is_correct: { $set: 1 },
                    },
                  },
                },
              },
            },
          },
        });
      else
        return update(state, {
          case_part: {
            [action.keyIndexPart]: {
              case_questions: {
                [action.keyIndexQues]: {
                  case_choices: {
                    [action.keyIndexAns]: {
                      is_correct: { $set: 1 },
                    },
                    [action.keyIndexAnsPre]: {
                      is_correct: { $set: 0 },
                    },
                  },
                },
              },
            },
          },
        });
    case actionType.SELECT_CORRECT_ANSWER_TRUE_FALSE:
      // pertanyaan
      if (action.keyIndexAnsPre < 0)
        return update(state, {
          case_part: {
            [action.keyIndexPart]: {
              case_questions: {
                [action.keyIndexQues]: {
                  case_choices: {
                    [action.keyIndexAns]: {
                      is_correct: { $set: 1 },
                    },
                  },
                },
              },
            },
          },
        });
      else
        return update(state, {
          case_part: {
            [action.keyIndexPart]: {
              case_questions: {
                [action.keyIndexQues]: {
                  case_choices: {
                    [action.keyIndexAns]: {
                      is_correct: { $set: 1 },
                    },
                    [action.keyIndexAnsPre]: {
                      is_correct: { $set: 0 },
                    },
                  },
                },
              },
            },
          },
        });
    case actionType.SELECT_CORRECT_ANSWER_MULTIPLE:
      // pertanyaan
      return update(state, {
        case_part: {
          [action.keyIndexPart]: {
            case_questions: {
              [action.keyIndexQues]: {
                case_choices: {
                  [action.keyIndexAns]: {
                    is_correct: state.case_part[action.keyIndexPart].case_questions[action.keyIndexQues].case_choices[action.keyIndexAns].is_correct === 1 ? { $set: 0 } : { $set: 1 },
                  },
                },
              },
            },
          },
        },
      });

    case actionType.ADD_TO_LIST_IMG:
      return update(state, {
        listImg: { $push: [action.imageName] },
      });

    case actionType.ADD_IMAGE_QUESTION:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQues]: {
                status_img: { $set: 1 },
                file_attached: { $set: action.image },
              },
            },
          },
        },
      });

    case actionType.ADD_IMAGE_FILE_QUESTION:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQues]: {
                img_file: { $set: action.imageFile },
              },
            },
          },
        },
      });

    case actionType.REMOVE_IMAGE:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQues]: {
                file_attached: { $set: null },
                status_img: { $set: 0 },
              },
            },
          },
        },
      });

    case actionType.ADD_IMAGE_ANSWER:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQues]: {
                case_choices: {
                  [action.indexAns]: {
                    status_img: { $set: 1 },
                    file_attached: { $set: action.image },
                  },
                },
              },
            },
          },
        },
      });

    case actionType.ADD_IMAGE_FILE_ANSWER:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQues]: {
                case_choices: {
                  [action.indexAns]: {
                    img_file: { $set: action.imageFile },
                  },
                },
              },
            },
          },
        },
      });

    case actionType.REMOVE_IMAGE_ANSWER:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQues]: {
                case_choices: {
                  [action.indexAns]: {
                    file_attached: { $set: null },
                    status_img: { $set: 0 },
                  },
                },
              },
            },
          },
        },
      });

    case actionType.EDIT_ANSWER_CORRECT: // ini untuk edit jawaban benar editCase
      if (action.indexAnswerOld < 0)
        return update(state, {
          case_part: {
            [action.indexPart]: {
              case_questions: {
                [action.indexQuestion]: {
                  case_choices: {
                    [action.indexAnswer]: {
                      is_correct: { $set: 1 },
                    },
                  },
                },
              },
            },
          },
        });
      else
        return update(state, {
          case_part: {
            [action.indexPart]: {
              case_questions: {
                [action.indexQuestion]: {
                  case_choices: {
                    [action.indexAnswer]: {
                      is_correct: { $set: 1 },
                    },
                    [action.indexAnswerOld]: {
                      is_correct: { $set: 0 },
                    },
                  },
                },
              },
            },
          },
        });
    case actionType.EDIT_ANSWER_CORRECT_TRUE_FALSE: // ini untuk edit jawaban benar editCase
      if (action.indexAnswerOld < 0)
        return update(state, {
          case_part: {
            [action.indexPart]: {
              case_questions: {
                [action.indexQuestion]: {
                  case_choices: {
                    [action.indexAnswer]: {
                      is_correct: { $set: 1 },
                    },
                  },
                },
              },
            },
          },
        });
      else
        return update(state, {
          case_part: {
            [action.indexPart]: {
              case_questions: {
                [action.indexQuestion]: {
                  case_choices: {
                    [action.indexAnswer]: {
                      is_correct: { $set: 1 },
                    },
                    [action.indexAnswerOld]: {
                      is_correct: { $set: 0 },
                    },
                  },
                },
              },
            },
          },
        });
    case actionType.EDIT_ANSWER_CORRECT_MULTIPLE: // ini untuk edit jawaban benar editCase
      return update(state, {
        case_part: {
          [action.indexPart]: {
            case_questions: {
              [action.indexQuestion]: {
                case_choices: {
                  [action.indexAnswer]: {
                    is_correct: state.case_part[action.indexPart].case_questions[action.indexQuestion].case_choices[action.indexAnswer].is_correct === 1 ? { $set: 0 } : { $set: 1 },
                  },
                },
              },
            },
          },
        },
      });

    case actionType.EDIT_RANDOM_QUESTION:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            random_question_order: { $set: action.newValue },
          },
        },
      });
    case actionType.EDIT_CASE_SENSITIFE:
      return update(state, {
        case_part: {
          [action.indexPart]: {
            is_case_sensitive: { $set: action.newValue },
          },
        },
      });

    case actionType.EDIT_RANDOM_ANSWER:
      if (state.case_part[action.indexPart]?.type_name === "menjodohkan") {
        return state;
      }
      return update(state, {
        case_part: {
          [action.indexPart]: {
            random_choice_order: { $set: action.newValue },
          },
        },
      });

    case actionType.TEACHER_MAKE_NEW_CASE:
      return {
        ...state,
        case_part: [],
        listImg: [],
        scheduleSelected: null,
        makeCaseBySchedule: false,
        schedules: null,
        doingMakeCase: true,
        statusSubmitted: false,
        cases: {
          name: "",
          school_id: action.schoolId,
          teacher_id: action.userId,
        },
        currentItemCase: {
          id: null,
          type_name: "",
          key: "",
          case_id: "",
          name: "",
          score_weight: "",
          random_question_order: false,
          random_choice_order: false,
          is_case_sensitive: false,
          case_questions: [
            {
              id: null,
              question: "",
              key: Date.now(),
            },
          ],
        },
      };

    case actionType.REQUEST_SUBMIT_EXAM_SUCCESS:
      return {
        ...state,
        statusSubmitted: action.payload,
      };

    case actionType.SELECT_COURSE_NEW_CASE:
      return {
        ...state,
        cases: {
          ...state.cases,
          course_id: action.courseSelected,
        },
      };

        case actionType.SELECT_CLASS_NEW_CASE:
      return {
        ...state,
        cases: {
          ...state.cases,
          class_grade_id: action.classSelected?.class_grade_id ?? action.classSelected?.value ?? action.classSelected,
          class_id: action.classSelected?.class_id ?? action.classSelected?.value ?? null,
          class_label: action.classSelected?.label || null,
        },
      };
    // ------------------------------------------------------------------- EDIT
    case actionType.LOAD_CASE_EDIT:
      return {
        ...state,
        listImg: [],
        cases: action.cases,
        case_part: action.case_parts,
        currentItemCase: {
          id: null,
          type_name: "",
          key: "",
          case_id: null,
          name: "",
          score_weight: "",
          random_question_order: false,
          random_choice_order: false,
          is_case_sensitive: false,
          case_questions: [
            {
              id: null,
              question: "",
              key: Date.now(),
            },
          ],
        },
      };

    case actionType.LOAD_PARSED_EXAM_DATA:
      // Transform parsed data from API into case_part structure
      const transformedCaseParts = action.parsedData.data.map((part, partIndex) => {
        const isMenjodohkan = part.type_name === 'menjodohkan' || part.name?.toUpperCase() === 'MENJODOHKAN';
        return {
          key: Date.now() + partIndex,
          type_name: part.type_name || "pilihan ganda", // Use parser type_name or fallback
          name: part.name || "",
          score_weight: 0,
          is_random_question: 0,
          is_random_answer: isMenjodohkan ? 1 : (part.is_random_answer || 0),
          random_choice_order: isMenjodohkan ? true : (part.random_choice_order ? true : false),
          random_question_order: false,
          is_case_sensitive: 0,
          case_questions: part.case_questions.map((question, qIndex) => {
            return {
              id: null,
              case_part_id: part.case_part_id,
              key: Date.now() + partIndex + qIndex + 1000,
              question: question.question || "",
              status_img: 0,
              file_attached: null,
              img_file: null,
              order: question.order || qIndex + 1,
              case_choices: question.case_choices.map((choice, cIndex) => {
                return {
                  id: null,
                  status_img: 0,
                  file_attached: null,
                  img_file: null,
                  case_question_id: question.case_question_id,
                  value: choice.value || "",
                  is_correct: choice.is_correct ? 1 : 0,
                  key: Date.now() + partIndex + qIndex + cIndex + 2000,
                  order: choice.order || cIndex + 1,
                };
              }),
              case_choices_answers: question.case_choices_answers && question.case_choices_answers.length > 0
                ? question.case_choices_answers.map((answer, aIndex) => {
                    const linkedChoiceId = answer.case_choice_id !== undefined
                      ? answer.case_choice_id
                      : (aIndex < question.case_choices.length ? (question.case_choices[aIndex]?.order || aIndex + 1) : null);
                    return {
                      case_question_id: question.case_question_id,
                      case_choice_id: linkedChoiceId,
                      value: answer.value || "",
                      is_correct: linkedChoiceId !== null ? (answer.is_correct ?? 1) : 0,
                    id: null,
                    status_img: 0,
                    file_attached: null,
                    img_file: null,
                    key: Date.now() + partIndex + qIndex + aIndex + 3000,
                    order: answer.order || aIndex + 1,
                    color: "#DEBA9D",
                    };
                  })
                : (part.type_name === 'menjodohkan' || part.name?.toUpperCase() === 'MENJODOHKAN') 
                  ? question.case_choices.map((choice, cIndex) => ({
                      case_question_id: question.case_question_id,
                      case_choice_id: null,
                      value: "",
                      is_correct: 0,
                      id: null,
                      status_img: 0,
                      file_attached: null,
                      img_file: null,
                      key: Date.now() + partIndex + qIndex + cIndex + 3000,
                      order: Date.now() + partIndex + qIndex + cIndex + 3000,
                      color: "#DEBA9D",
                    }))
                  : [],
            };
          }),
        };
      });

      return {
        ...state,
        case_part: transformedCaseParts,
        currentItemCase: {
          id: null,
          type_name: "",
          key: "",
          case_id: null,
          name: "",
          score_weight: "",
          random_question_order: false,
          random_choice_order: false,
          is_case_sensitive: false,
          case_questions: [],
        },
      };

    case actionType.LOAD_BANK_SOAL_DATA:
      const newCaseParts = [...state.case_part];
      
      action.bankSoalQuestions.forEach((q, index) => {
        const typeName = q.type_name || "pilihan ganda";
        let targetPartIndex = newCaseParts.findIndex(p => p.type_name === typeName);
        
        if (targetPartIndex === -1) {
          const isMenjodohkan = typeName === 'menjodohkan';
          // Create new part
          newCaseParts.push({
            key: Date.now() + index,
            type_name: typeName,
            name: "Bagian " + typeName,
            score_weight: 0,
            is_random_question: 0,
            is_random_answer: isMenjodohkan ? 1 : 0,
            random_choice_order: isMenjodohkan ? true : false,
            random_question_order: false,
            is_case_sensitive: 0,
            case_questions: []
          });
          targetPartIndex = newCaseParts.length - 1;
        }

        // Deep copy and clean up the question object for insertion
        const newQuestion = {
          ...q,
          id: null,
          case_part_id: null,
          status_img: q.file_attached ? 1 : 0,
          key: Date.now() + index + 1000,
          case_choices: (q.case_choices || []).map((c, cIdx) => ({
            ...c,
            id: null,
            case_question_id: null,
            status_img: c.file_attached ? 1 : 0,
            key: Date.now() + index + cIdx + 2000
          })),
          case_choices_answers: (q.case_choices_answers || []).map((ca, caIdx) => ({
            ...ca,
            id: null,
            case_question_id: null,
            status_img: ca.file_attached ? 1 : 0,
            key: Date.now() + index + caIdx + 3000
          }))
        };

        newCaseParts[targetPartIndex].case_questions.push(newQuestion);
      });

      // No longer recalculating weights evenly to 100.
      // score_weight inherits from existing part or defaults to 0.

      return {
        ...state,
        case_part: newCaseParts
      };


    default:
      return state;

    case actionType.TEACHER_EDIT_CASES:
      return {
        ...state,
        doingEditCase: action.status,
        statusSubmitted: false,
      };

    case actionType.EDIT_CASE_FINISHED:
      return {
        // ...state,
        statusSubmitted: action.status,
        doingEditCase: false,
        makeCaseBySchedule: false,
        doingMakeCase: false,
      };
  }
};
export default ExamReducers;
